import { z } from "zod";

export const hasMultipleOrders = {
  input: z.object({}).optional(),
  output: z.boolean(),
};
